import React, { useEffect, useState } from "react"
import PropTypes from "prop-types"
import { Button, Col, Form, Input, Label, Row, Table } from "reactstrap"
// Toastify
import { ToastContainer, toast } from "react-toastify"
import "react-toastify/dist/ReactToastify.css"
import { Slide } from "react-toastify"
import API from "../../../api"
import { withTranslation } from "react-i18next"
import { AvForm, AvField } from "availity-reactstrap-validation"
import DatePicker from "react-datepicker";
import getDay from "date-fns/getDay"
import Select from "react-select"
import Switch from "react-switch"
const AddEtudiantOrientation = props => {
  const [array, setArray] = useState([])
  const [specialite, setSpecialite] = useState([])
  const [selectSpecilaite, setSelectSpecilaite] = useState("")
  var userAuthScolarite = JSON.parse(localStorage.getItem("userAuthScolarite"))
  var annee_id = userAuthScolarite.user.annee_id
  var user_id = userAuthScolarite.user.id
  const save = async () => {
    const cleanedArray = array.map(s => ({
      ...s,
      etat: s.etat !== undefined ? s.etat : 0
    }));
      API.post("matiere_orientation/store_matieres", {
        annee_id,
        user_id,
        specialite_orientation_id: selectSpecilaite.value,
        array: cleanedArray,
      }).then(res => {
        toast.success(" 🔓✔️  Spécialité Mastére ajoutée Avec succès", {
          containerId: "A",
        })
        props.setSection(1)
      })
  }
  useEffect(async () => {
    const resSpec = await API.post("specialite_orientation/select_specialite", {
      annee_id,
    }).then(resSpec => {
      setSpecialite(resSpec.data.specialites)
    })
  }, [])
  const Offsymbol = () => {
    return (
      <div
        title="Désactivé"
        style={{
          display: "flex",
          justifyContent: "center",
          alignItems: "center",
          height: "100%",
          fontSize: 12,
          color: "#fff",
          paddingRight: 2,
        }}
      >
        D
      </div>
    );
  };

  const OnSymbol = () => {
    return (
      <div
        title="Activé"
        style={{
          display: "flex",
          justifyContent: "center",
          alignItems: "center",
          height: "100%",
          fontSize: 12,
          color: "#fff",
          paddingRight: 2,
        }}
      >
        A
      </div>
    );
  };

  const handleEtatChange = (index) => {
    setArray(prev => {
      const updated = [...prev];
      updated[index].etat = updated[index].etat === 1 ? 0 : 1;
      return updated;
    });
  };
  const getMatiere = async event => {
    setArray([])
    var specialite_id = event.value
    setSelectSpecilaite(event)
    const res = await API.post("matiere_orientation/get_matiere", {
      specialite_orientation_id: specialite_id,
      specialite_source_id: event.specialite_source_id,
      annee_id,
    }).then(res => {
      setArray(res.data.matieres)
    })
  }
  return (
    <React.Fragment>
      <Row>
        <Col lg="6">
          <div className="mb-3">
            <Label for="basicpill-firstname-input1">Spécialité :</Label>
            <Select
              options={specialite}
              isSearchable={true}
              onChange={e => getMatiere(e)}
            />
          </div>
        </Col>
      </Row>
      <Row>
        <AvForm>
          <Form>
            <Row >
              <Table className="mt-3" striped bordered hover>
                <thead>
                  <th style={{textAlign: "center"}}></th>
                  <th style={{textAlign: "center"}}>Semestre</th>
                  <th style={{textAlign: "center"}}>Spécialité</th>
                  <th style={{textAlign: "center"}}>Niveau</th>
                  <th style={{textAlign: "center"}}>Matière</th>
                  <th style={{textAlign: "center"}}>Etat</th>
                </thead>
                <tbody>

                {array.map((specialite, index) => (
                  <tr key={index}>
                    <td style={{textAlign: "center"}}>{index + 1}</td>
                    <td style={{textAlign: "center"}}>{specialite.semestre}</td>
                    <td style={{textAlign: "center"}}>{specialite.specialite}</td>
                    <td style={{textAlign: "center"}}>{specialite.niveau}</td>
                    <td style={{textAlign: "center"}}>{specialite.label}</td>
                    <td style={{textAlign: "center"}}>
                      <Switch
                        uncheckedIcon={<Offsymbol />}   // Désactivé
                        checkedIcon={<OnSymbol />}       // Activé
                        className="me-1 mb-sm-8 mb-2"
                        onColor="#34c38f"
                        checked={specialite.etat === 1}  // 🔥 Correct
                        onChange={() => handleEtatChange(index)}  // 🔥 Pour modifier l’état
                      />
                    </td>
                  </tr>
                ))}
                </tbody>

              </Table>
            </Row>
          </Form>
          <div style={{ display: "flex", justifyContent: "center" }}>
            {" "}
            <Col lg="6">
              <div
                style={{
                  display: "flex",
                  justifyContent: "flex-end",
                }}
                className="text-center mt-4"
              >
                <Button
                  type="button"
                  color="warning"
                  className="btn btn-warning  mb-2 me-2"
                  onClick={props.back}
                >
                  {props.t("Annuler")}
                </Button>
              </div>
            </Col>
            <Col lg="6">
              <div
                style={{
                  display: "flex",
                  justifyContent: "flex-start",
                }}
                className="text-center mt-4"
              >
                <button
                  type="button"
                  className="btn btn-primary "
                  onClick={save}
                >
                  {props.t("Confirmer")}
                </button>
              </div>
            </Col>
          </div>
        </AvForm>
      </Row>
      <ToastContainer
        transition={Slide}
        enableMultiContainer
        containerId={"A"}
        position={toast.POSITION.TOP_RIGHT}
        autoClose={2500}
      />
    </React.Fragment>
  )
}

export default withTranslation()(AddEtudiantOrientation)
AddEtudiantOrientation.propTypes = {
  history: PropTypes.object,
  back: PropTypes.object,
  setSection: PropTypes.object,
  t: PropTypes.any,
}
